import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { push } from 'connected-react-router'
import queryString from 'query-string'
import { usePrevious } from '@ocean/hooks'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { useLazySelector } from 'hooks'
import { loadCustomerConfiguration } from 'core/system/slices/system'
import { SiteType } from 'core/system/types'
import authRoutes from 'modules/Auth/routing/routes'

const { Spinner } = common

type QueryParams = {
  ecn?: string
}

// External layer
// Setup public Application part
const ExternalLayer: React.FC = ({ children }) => {
  const dispatch = useDispatch()
  const [initializationLoading, setInitializationLoading] = useState(true)
  const { customerInformationLoading, siteType, defaultCustomer, isInstallationRegistered } =
    useLazySelector(({ system }) => {
      const { isLoading: customerInformationLoading, result: customerInformationResult } =
        system.customerInformation
      const { result: systemInformationResult } = system.systemInformation
      return {
        customerInformationLoading,
        isInstallationRegistered: customerInformationResult?.information.isInstallationRegistered,
        siteType: systemInformationResult?.information.siteType,
        defaultCustomer: systemInformationResult?.information.defaultCustomer,
      }
    })
  const prevCustomerInformationLoading = usePrevious(customerInformationLoading)
  const location = useLocation()
  const queryParams: QueryParams = queryString.parse(location.search)
  const { ecn } = queryParams

  const isVessel = siteType === SiteType.Vessel
  const vesselCustomer = isVessel ? defaultCustomer : null
  const ecnCustomer = ecn ? atob(ecn) : null

  useEffect(() => {
    const customer = ecnCustomer || vesselCustomer
    if (customer) {
      dispatch(loadCustomerConfiguration(customer))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const isCustomerInformationLoaded =
      prevCustomerInformationLoading && !customerInformationLoading
    if (isCustomerInformationLoaded) {
      if (isVessel && isInstallationRegistered === false) {
        dispatch(push(authRoutes.registration))
      }
      setInitializationLoading(false)
    }
  }, [customerInformationLoading, prevCustomerInformationLoading]) // eslint-disable-line react-hooks/exhaustive-deps

  if (ecn && initializationLoading) return <Spinner mode={Mode.Light} />

  return <>{children}</>
}

export default ExternalLayer
